import React, {useContext} from 'react';
import {FeatureFlagsContext} from '@core-ui/feature-flags';
import {forBrands, styled, useTheme} from '@core-ui/react-stitch';
import {BreakpointContext, LARGE} from '@core-ui/breakpoint-provider';

const CatPageTitleText = ({children}) => {
  const theme = useTheme();
  const {enabledFeatures} = useContext(FeatureFlagsContext);
  const brTertiaryFontsEnabled = enabledFeatures['br-tertiary-font'];

  const brandStyles = forBrands(theme, {
    gap: () => ({
      ...theme.font.primary,
      color: theme.color.g2,
      fontWeight: 700,
    }),
    gapfs: () => ({
      ...theme.font.primary,
      color: theme.color.g2,
      fontWeight: 700,
    }),
    br: () => ({
      ...(brTertiaryFontsEnabled ? ({
          ...theme.font.tertiary,
          fontSize: '2rem',
          fontWeight: 400,
          letterSpacing: '-0.02em',
        }) : ({
          ...theme.font.primary,
          fontWeight: 700,
          letterSpacing: '0.15em',
        })
      ),
      color: theme.color.g1,
    }),
    brfs: () => ({
      ...theme.font.primary,
      fontWeight: 700,
      letterSpacing: '0.15em',
      color: theme.color.g1,
    }),
    at: () => ({
      ...theme.font.primary,
      color: theme.color.gray54,
      fontSize: `2.25rem`,
      letterSpace: 2,
    }),
    on: () => ({
      ...theme.font.primary,
      color: theme.color.g2,
      fontSize: '1.5rem',
      fontWeight: 400,
      letterSpacing: '0.10em',
    }),
  });

  const Header = styled.h1(() => ({
    display: 'inline',
    lineHeight: 1,
    fontSize: `1.6875em`,
    ...brandStyles,
  }));
  return <Header>{children}</Header>;
};

const CatPageTitle = ({children}) => {
  const theme = useTheme();
  const {greaterOrEqualTo} = useContext(BreakpointContext);
  const greaterOrEqualToLarge = greaterOrEqualTo(LARGE);

  const catPageTitleStyle = {
    textAlign: 'center',
    textTransform: 'uppercase',
    padding: greaterOrEqualToLarge ? '2rem 0' : '1rem 0',
    ...forBrands(theme, {
      at: () => ({
        margin: 0,
        maxWidth: '100%',
        ...greaterOrEqualToLarge ? {background: 'none'} : {},
      }),
    }),
  };

  return (
    <div className="limit-width clearfix" css={catPageTitleStyle}>
      {children}
    </div>
  );
};

export const FallbackHeader = ({
  position,
  shouldHideTitle,
  categoryName,
}) => {
  if (
    shouldHideTitle ||
    position === 'topPrimary' ||
    position === 'bottom' ||
    categoryName === '') {
    return null;
  }

  return (
    <CatPageTitle>
      <CatPageTitleText>{categoryName}</CatPageTitleText>
    </CatPageTitle>
  );
};

export default {FallbackHeader};
